import React from 'react';
import { Route } from 'react-router-dom';
import { AllRouteConstants } from '../../../router/routes';
import { DepositFund, DepositLog } from '../pages';
import { useAppSelector } from '../../../hooks/useAppSelector';
import Redirect from '../../../HoC/Redirect';

const DepositRoutes = () => {
	const { mode } = useAppSelector((state) => state.cachedReducer);

	return mode == 'real' ? (
		<>
			<Route
				path={AllRouteConstants.user.deposit_fund}
				element={<DepositFund />}
			/>
			<Route
				path={AllRouteConstants.user.deposit_history}
				element={<DepositLog />}
			/>
		</>
	) : (
		<>
			<Route
				path={AllRouteConstants.user.deposit_fund}
				element={<Redirect path={AllRouteConstants.user.home} />}
			/>
			<Route
				path={AllRouteConstants.user.deposit_history}
				element={<Redirect path={AllRouteConstants.user.home} />}
			/>
		</>
	);
};

export default DepositRoutes;
